import axios from 'axios'

const countries = {
    async getCountries() {
        return await axios.get('/countries')
    }
}

export default countries
